<template>
  <div class="pt-3">
    <div class="row justify-content-md-center">
      <b-nav class="col-md-12" fill>
        <b-nav-item active>Summary</b-nav-item>
        <b-nav-item ><router-link to="/admin/companies">Companies</router-link></b-nav-item>
        <b-nav-item ><router-link to="/admin/users">Users</router-link></b-nav-item>
        <b-nav-item ><router-link to="/admin/vehicles">Vehicles</router-link></b-nav-item>
        <b-nav-item ><router-link to="/admin/employees">Employees</router-link></b-nav-item>
      </b-nav>
    </div>
    <b-row class="mt-4">
      <b-col sm="6" lg="6">
        <div class="box__container">
          <i class="fa fa-building-o fa__bg--red"></i>
          <b-row>
            <b-col
              v-for="(cc, index) in count_company"
              :lg="index === 0 ? 12 : 6" sm="12" :key="index"
              :style="{ borderRight: index % 2 !== 1 && 'none' }">
              <b-card no-body class="p-3 m-3">
                <p class="mb-0">
                  <strong class="fs-20">{{ cc.data }}</strong>
                  <span class="fs-16">{{ cc.label }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="6" lg="6">
        <div class="box__container">
          <i class="fa fa-users fa__bg--green"></i>
          <b-row>
            <b-col
              v-for="(cc, index) in count_user"
              :lg="index === 0 ? 12 : 6" sm="12" :key="index"
              :style="{ borderRight: index % 2 !== 1 && 'none' }">
              <b-card no-body class="p-3 m-3">
                <p class="mb-0">
                  <strong class="fs-20">{{ cc.data }}</strong>
                  <span class="fs-16">{{ cc.label }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="6" lg="6">
        <div class="box__container">
          <i class="fa fa-car fa__bg--lime"></i>
          <b-row>
            <b-col
              v-for="(cc, index) in count_vehicle"
              :lg="index === 0 ? 12 : 6" sm="12" :key="index"
              :style="{ borderRight: index % 2 !== 1 && 'none' }">
              <b-card no-body class="p-3 m-3">
                <p class="mb-0">
                  <strong class="fs-20">{{ cc.data.length }}</strong>
                  <span class="fs-16">{{ cc.label }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="6" lg="6">
        <div class="box__container">
          <i class="fa fa-user-o fa__bg--blue"></i>
          <b-row>
            <b-col
              v-for="(cc, index) in count_employee"
              :lg="index === 0 ? 12 : 6" sm="12" :key="index"
              :style="{ borderRight: index % 2 !== 1 && 'none' }">
              <b-card no-body class="p-3 m-3">
                <p class="mb-0">
                  <strong class="fs-20">{{ cc.data }}</strong>
                  <span class="fs-16">{{ cc.label }}</span>
                </p>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loaded: false,
    };
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
    ]);
    this.$store.commit('companies/CLEAR_QUERY');
    this.$store.commit('companies/SET_QUERY_TYPE', null);
    this.$store.commit('companies/SET_QUERY_ACTIVE', 'true');
    this.$store.dispatch('companies/LOAD_INFO');

    this.$store.commit('users/CLEAR_QUERY');
    this.$store.commit('users/SET_QUERY_TYPE', null);
    this.$store.commit('users/SET_QUERY_ACTIVE', 'true');
    this.$store.dispatch('users/LOAD_INFO');

    this.$store.commit('vehicles/CLEAR_QUERY');
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      const count_all = this.$store.getters['vehicles/count_all'];
      this.$store.commit('vehicles/SET_QUERY_COUNT', count_all);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });

    this.$store.commit('employees/CLEAR_QUERY');
    this.$store.dispatch('employees/LOAD_INFO');
  },
  computed: {
    count_company() {
      const company_count = [];
      company_count.push({ label: 'Companies', data: this.$store.getters['companies/count_all'] });
      company_count.push({ label: 'Company Default', data: this.$store.getters['companies/count_default'] });
      company_count.push({ label: 'Transporter', data: this.$store.getters['companies/count_transporter'] });
      company_count.push({ label: 'Customer', data: this.$store.getters['companies/count_customer'] });
      company_count.push({ label: 'Company Active', data: this.$store.getters['companies/count_active'] });
      company_count.push({ label: 'Company Blocked', data: this.$store.getters['companies/count_inactive'] });

      return company_count;
    },
    count_user() {
      const user_count = [];
      user_count.push({ label: 'Users', data: this.$store.getters['users/count_all'] });
      user_count.push({ label: 'User Default', data: this.$store.getters['users/count_default'] });
      user_count.push({ label: 'System Admin', data: this.$store.getters['users/count_system_admin'] });
      user_count.push({ label: 'Admin', data: this.$store.getters['users/count_admin'] });
      user_count.push({ label: 'User Active', data: this.$store.getters['users/count_active'] });
      user_count.push({ label: 'User Blocked', data: this.$store.getters['users/count_inactive'] });

      return user_count;
    },
    count_vehicle() {
      const vehicle_count = [];
      const vehicles = this.$store.getters['vehicles/vehicles'];
      vehicle_count.push({ label: 'Vehicles', data: vehicles });
      vehicle_count.push({ label: 'Vehicle GPS', data: vehicles.filter(vehicle => vehicle.gps_devices.length > 0) });
      vehicle_count.push({ label: 'Vehicle Non GPS', data: vehicles.filter(vehicle => vehicle.gps_devices.length <= 0) });

      return vehicle_count;
    },
    count_employee() {
      const employee_count = [];
      employee_count.push({ label: 'Employees', data: this.$store.getters['employees/count_all'] });
      employee_count.push({ label: 'Default', data: this.$store.getters['employees/count_default'] });
      employee_count.push({ label: 'Loader', data: this.$store.getters['employees/count_loader'] });
      employee_count.push({ label: 'Driver', data: this.$store.getters['employees/count_driver'] });
      employee_count.push({ label: 'Operator', data: this.$store.getters['employees/count_operator'] });

      return employee_count;
    },
  },
};
</script>
<style lang="sass" scoped>
.box__container
  min-height: 160px
  margin-bottom: 1.5rem
  text-align: center
  background: #fff
  border: 1px solid #c2cfd6

  &>i
    display: block
    margin: -1px -1px 0
    font-size: 40px
    line-height: 90px

  &>.row>div:not(:first-child)
    border-right: 1px solid #c2cfd6

.fa__bg--blue
  background: #64B5F6

.fa__bg--red
  background: #E57373

.fa__bg--green
  background: #81C784

.fa__bg--lime
  background: #DCE775

.fs-20
  font-size: 20px

.fs-16
  font-size: 16px

@media only screen and (max-width: 768px)
  .box__container>.row>div
    border-right: none !important
</style>



// WEBPACK FOOTER //
// src/views/pages/admin/Index.vue